import React, {Component} from 'react';
import Interest from '../Interest/Interest';
import throttle from '../../helpers/throttle';

class SectionInterest extends Component {
	constructor() {
		super();
		this.lastScroll = 0;
		this.state = {
			selectedItem: 0
		}
	}

	onChangeSelectedItem = (newSelectedItem) => {
		this.setState({selectedItem: newSelectedItem});
	};

	componentDidMount() {
		window.addEventListener("scroll", throttle(this.handleScroll, 350));
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", throttle(this.handleScroll, 350));
	}

	handleScroll = () => {
		if (Math.abs(+this.slide.getBoundingClientRect().top) < 200) {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.lastScroll) { //down
				if (this.state.selectedItem < 3) {
					this.onChangeSelectedItem(this.state.selectedItem + 1);
				}
			} else if (scrollTop < this.lastScroll) { //up
				if (this.state.selectedItem > 0) {
					this.onChangeSelectedItem(this.state.selectedItem - 1);
				}
			}
			this.lastScroll = scrollTop;
		}
	};

	render() {
		const {selectedItem} = this.state;
		return (
			<section className="section section--overflow sticky">
				<div className="wrapper sticky__item" ref={el => this.slide = el}>
					<Interest selectedItem={selectedItem} onChangeSelectedItem={this.onChangeSelectedItem}/>
				</div>
			</section>
		)
	};
}

export default SectionInterest;



// WEBPACK FOOTER //
// ./src/components/SectionInterest/SectionInterest.js